<template>
  <v-sheet>

    <template v-if="!isFormReadOnly && !props.connect_uuid">

      <file-input @onFileAdded="fileAdded" :config="fileInputConfig" />

      <v-dialog width="auto" theme="light" class="d-flex flex-row justify-center align-center"
          @update:modelValue="onUpdateModelDialog" v-if="props.target_uuid">
        <template v-slot:activator="{ props }">

          <v-btn v-bind="props" prepend-icon="mdi-link-plus" size="large" color="orange-darken-3"
              class="mt-2" :block="mobile">
            Collega esistente</v-btn>
        </template>
        <template v-slot:default="{ showDialogLinker }">

          <v-card>
            <v-card-text>
              <files-browser title="Connetti" :connect_uuid="props?.target_uuid" :purpose="props?.purpose" :readonly="true"
                  @onFileLinkedChanged="fileLinked($event, showDialogLinker);" />
            </v-card-text>
          </v-card>
        </template>
      </v-dialog>


    </template>




    <template v-if="loading">
      <div class="d-flex align-center justify-center mt-6">
        <v-progress-circular indeterminate :size="50" color="primary"></v-progress-circular>
      </div>
    </template>
    <template v-else>
      <template v-if="Object.keys(filesByMimeType).length">
        <v-switch v-if="!props.target_uuid" hide-details color="primary" inset v-model="groupBy" true-value="type"
            label="Raggruppa per tipologia" class="mt-6" :disabled="false" :readonly="false" />
        <template v-if="groupBy == 'type'">
          <v-expansion-panels flat variant="accordion" multiple>
            <v-expansion-panel v-for="(fileList, mimetype) of filesByMimeType" :key="mimetype">
              <v-expansion-panel-title color="blue-darken-3" density='compact'>
                <v-icon size="default" class="mr-2">mdi-{{ mimetypeIcon(fileList[0].mimetype) }}</v-icon>
                {{ mimetype.toUpperCase().replaceAll("/", " / ") }}</v-expansion-panel-title>
              <v-expansion-panel-text>

                <v-list color="primary" :border="2" density='compact' class="ma-0">
                  <template v-for="(file, i) in fileList" :key="i">
                    <v-list-item color="primary" :border="false" class="pa-0" :style="rowStyle(i)"
                        :active="activeFile == file" active-class="rowshowFileDialog"
                        @click="activeFile = file; showFileDialog = true">



                      <template v-slot:prepend>
                        <v-btn :id="'btn-view-' + file.id" class="ma-2 mr-4" size="" v-bind="props"
                            :color="activeFile == file ? 'blue-grey-darken-4' : 'blue-darken-3'">
                          <!-- <v-icon size="x-large" class="ma-3">mdi-{{ mimetypeIcon(file.mimetype) }}</v-icon> -->
                        </v-btn>
                      </template>

                      <v-list-item-title>
                        {{ new Date(file.created_at).toLocaleString() }}
                      <span v-if="file.purpose">
                        ({{ file.purpose }})
                      </span> 
                      </v-list-item-title>

                      <v-list-item-subtitle>
                        <pre>{{ sizeInBytesToHumanreadable(file.size) }} - {{ file.name }}</pre>
                      </v-list-item-subtitle>

                      <template v-slot:append>
                        <v-btn v-if="file?.target_uuid" color="orange-darken-3" class="ma-1" size=""
                            variant="flat" readonly>
                          <v-icon size="x-small" class="ma-3">mdi-link</v-icon>
                        </v-btn>
                        <v-btn v-else color="white" class="ma-1" size="" readonly variant="flat">
                          <v-icon size="x-small" class="ma-3">mdi-link-off</v-icon>
                        </v-btn>
                          <v-btn v-if="file?.state === 201 || file?.state === 409" color="green-darken-3" class="ma-1"
                              variant="flat" size="" readonly>
                            <v-icon size="x-small" class="ma-3">mdi-cloud-check</v-icon>
                          </v-btn>
                          <v-btn v-else color="white" class="ma-1" size="" readonly variant="flat">
                            <v-icon size="" class="ma-3">mdi-cloud-off</v-icon>
                          </v-btn>
                      </template>


                    </v-list-item>
                  </template>
                </v-list>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
        <template v-else>

          <v-list color="primary" :border="2" density='compact' class="ma-0">
            <template v-for="(file, i) in files" :key="i">
              <v-list-item color="primary" :border="false" :style="rowStyle(i)"
                  :active="activeFile == file" active-class="rowshowFileDialog"
                  @click="activeFile = file; showFileDialog = true" lines="three" class="pa-0">



                <template v-slot:prepend>
                  <v-icon :color="activeFile == file ? 'blue-darken-5' : 'grey-darken-3'" size="default"
                      class="pa-0 ml-3 prepend_centerer">mdi-{{ mimetypeIcon(file.mimetype) }}</v-icon>
                </template>

                <div class="pr-8">

                  <v-list-item-title class="ma-0">

                    <!-- <v-icon 
                    :color="activeFile == file ? 'blue-darken-5' : 'grey-darken-3'"
                    size="default" class="mx-2">mdi-{{ mimetypeIcon(file.mimetype) }}</v-icon> -->
                    <!-- (#{{ file.id }}) -->
                    <span>
                      {{ new Date(file.created_at).toLocaleString() }} 
                      <span v-if="file.purpose">
                        ({{ file.purpose }})
                      </span> 
                    </span>
                  </v-list-item-title>

                  <v-list-item-subtitle>
                    <span  class="text-truncate">
                      {{ file.name }}
                    </span><br>
                    <span>
                      {{ sizeInBytesToHumanreadable(file.size) }} - {{ file.mimetype }}
                    </span>
                  </v-list-item-subtitle>

                </div>
                <template v-slot:append>
                  <v-spacer />
                  <v-btn v-if="file?.target_uuid" color="orange-darken-3" class="ma-1" size="" readonly
                      variant="flat">
                    <v-icon size="x-small" class="ma-3">mdi-link</v-icon>
                  </v-btn>
                  <v-btn v-else color="white" class="ma-1" size="" readonly variant="flat">
                    <v-icon size="x-small" class="ma-3">mdi-link-off</v-icon>
                  </v-btn>

                    <v-btn v-if="file?.state === 201 || file?.state === 409" color="green-darken-3" class="ma-1"
                        variant="flat" size="" readonly>
                      <v-icon size="x-small" class="ma-3">mdi-cloud-check</v-icon>
                    </v-btn>
                    <v-btn v-else color="white" class="ma-1" size="" readonly variant="flat">
                      <v-icon size="" class="ma-3">mdi-cloud-off</v-icon>
                    </v-btn>
                </template>


              </v-list-item>
            </template>
          </v-list>
        </template>
      </template>
      <template v-else>
        <p class="text-headline-small mt-3" v-if="target_uuid">Nessun media collegato</p>
        <p class="text-headline-small mt-3" v-if="target_uuid == null">
          <span v-if="connect_uuid">Nessun file disponibile</span>
          <span v-else>Lista file vuota</span>
        </p>
      </template>
    </template>
  </v-sheet>

  <v-dialog fullscreen transition="dialog-bottom-transition" theme="dark" v-model="showFileDialog" scrim="black">
    <file-viewer :activeFile="activeFile" :current_uuid="props.target_uuid" :connect_uuid="props.connect_uuid"
        @onFileDeleted="fileDeleted(); showFileDialog = false"
        @onFileLinkedChanged="fileLinked($event, showFileDialog)"
        @swipe="receiveSwipe($event)"
        >

      <template #actions>

        <v-btn v-if="filesByMimeTypeFlat.length > 1" @click="prevFileByMimeTypeFlat(activeFile)"
            color="grey-darken-3" class="mr-2 pa-6 flex-grow-0" size="" variant="elevated">
          <v-icon size="x-large" class="">mdi-arrow-left</v-icon>
        </v-btn>
        <v-spacer />
        <v-btn variant="outlined" size="large" color="white" @click="showFileDialog = false" class="ma-2">
          <v-icon>mdi-chevron-down</v-icon>
          Indietro</v-btn>

        <v-spacer />
        <v-btn v-if="filesByMimeTypeFlat.length > 1" @click="nextFileByMimeTypeFlat(activeFile)"
            color="grey-darken-3" class="ml-2 pa-6 flex-grow-0" size="" variant="elevated">
          <v-icon size="x-large" class="">mdi-arrow-right</v-icon>
        </v-btn>
      </template>
    </file-viewer>
  </v-dialog>
</template>






<script setup>

import { ref, computed, onMounted, inject } from "vue";

import { useFilesStore } from "@/store/files";

import FilesBrowser from '@/components/media/FilesBrowser.vue'


import FileViewer from '@/components/media/FileViewer.vue'
import FileInput from '@/components/media/FileInput.vue'
// import { useDisplay } from 'vuetify'

// import AudioRecorder from '@/components/media/AudioRecorder.vue'

import { useDisplay } from "vuetify";



const emit = defineEmits(['onFileLinkedChanged'])

const emitFileLinkedChanged = (name) => {
  emit('onFileLinkedChanged', name)
}

const { mobile } = useDisplay()

const isFormReadOnly = ref(false) 


// const groupBy = ref("type")
const groupBy = ref(false)


// Destructure only the keys you want to use
// const { smAndDown } = useDisplay()

const filesStore = useFilesStore();

const props = defineProps(
  {
    target_uuid: {
      type: String, default: () => {
        return null
      }
    },
    purpose: {
      type: String, default: () => {
        return "no-default-here-,-should-become-mandatory"
      }
    },
    connect_uuid: {
      type: String, default: () => {
        return null
      }
    },
    title: {
      type: String, default: () => {
        return "Media"
      }
    },
    readonly: {
      type: Boolean, default: () => {
        return true
      }
    }
  })


const showFileDialog = ref(false)
const loading = ref(true)


// const audioAdded = (name) => {
//   console.log("audioAdded", name)
//   getFiles()
// }

const fileInputConfig = {
  fab: false,
  label: "Aggiungi nuovo",
  title: null,
  block: mobile,
  target_uuid: props.target_uuid,
  purpose: props.purpose,
  file: {
    audio: true,
    video: true,
    image: true,
    geojson: false,
  },
  capture: {
    audio: true,
    video: true,
    image: true,
  },
}




const fileAdded = (name) => {
  console.log("fileAdded", name)
  getFiles()
}



const fileLinked = (name) => {
  console.log("fileLinked", name)
  showFileDialog.value = false
  emitFileLinkedChanged(name)
  getFiles()
}

const receiveSwipe = (direction) => {
  console.log("Swipe received:", direction)
  if (filesByMimeTypeFlat.length > 1){
    if (direction === "Left") {
      prevFileByMimeTypeFlat(activeFile.value)
    } else if (direction === "Right") {
      nextFileByMimeTypeFlat(activeFile.value)
    }
  }
}



const files = ref([])
const activeFile = ref(null)

const getFiles = async () => {
  const allFiles = await filesStore.allFilesWithoutContent()


  loading.value = false
  // console.log("connect_uuid",props?.connect_uuid)

  if (props.target_uuid) {
    files.value = allFiles.filter((file) => file.target_uuid == props.target_uuid)
    return
  }

  if (props?.connect_uuid) {
    files.value = allFiles.filter((file) => !file.target_uuid)
    return
  }

  files.value = allFiles
  return

  // console.log("files", files.value)
}

// const filesByExtension = computed(() => {

//   const filesByExtension = {}

//   files.value.forEach((file) => {
//     if (!filesByExtension[file.extension]) {
//       filesByExtension[file.extension] = []
//     }
//     filesByExtension[file.extension].push(file)
//   })

//   return filesByExtension

// })


// const filesByExtensionFlat = computed(() => {
//   const filesByExtensionFlat = []
//   for (const extgrp in filesByExtension.value) {
//     // console.log(extgrp)
//     for (const file of filesByExtension.value[extgrp]) {
//       // console.log(file)

//       filesByExtensionFlat.push(file)
//     }
//   }
//   return filesByExtensionFlat
// })


// const prevFileByExtensionFlat = (file, showFileDialog) => {
//   showFileDialog = false

//   if (!filesByExtensionFlat.value) return
//   let id = filesByExtensionFlat.value.indexOf(file)

//   id = id - 1
//   id = (id + filesByExtensionFlat.value.length) % filesByExtensionFlat.value.length

//   const newFile = filesByExtensionFlat.value[id]

//   activeFile.value = newFile

//   document.getElementById('btn-view-' + newFile.id).click()

// }

// const nextFileByExtensionFlat = (file, showFileDialog) => {
//   showFileDialog = false

//   if (!filesByExtensionFlat.value) return


//   let id = filesByExtensionFlat.value.indexOf(file)

//   id = id + 1
//   id = (id + filesByExtensionFlat.value.length) % filesByExtensionFlat.value.length

//   const newFile = filesByExtensionFlat.value[id]

//   activeFile.value = newFile

//   document.getElementById('btn-view-' + newFile.id).click()

// }






const filesByMimeType = computed(() => {

  const filesByMimeType = {}

  files.value.forEach((file) => {
    if (!filesByMimeType[file.mimetype]) {
      filesByMimeType[file.mimetype] = []
    }
    filesByMimeType[file.mimetype].push(file)
  })

  return filesByMimeType

})


const filesByMimeTypeFlat = computed(() => {
  const filesByMimeTypeFlat = []
  for (const extgrp in filesByMimeType.value) {
    // console.log(extgrp)
    for (const file of filesByMimeType.value[extgrp]) {
      // console.log(file)

      filesByMimeTypeFlat.push(file)
    }
  }
  return filesByMimeTypeFlat
})


const sizeInBytesToHumanreadable = (size) => {

  if (!size) return "? KB"

  size = parseFloat(size)

  if (size < 1024) {
    return size + " B"
  }
  if (size < 1024 * 1024) {
    return Math.round(size / 1024) + " KB"
  }
  if (size < 1024 * 1024 * 1024) {
    return Math.round(size / 1024 / 1024) + " MB"
  }
  return Math.round(size / 1024 / 1024 / 1024) + " GB"

}
const prevFileByMimeTypeFlat = (file) => {

  if (!filesByMimeTypeFlat.value) return
  let id = filesByMimeTypeFlat.value.indexOf(file)

  id = id - 1
  id = (id + filesByMimeTypeFlat.value.length) % filesByMimeTypeFlat.value.length

  const newFile = filesByMimeTypeFlat.value[id]

  activeFile.value = newFile
  // console.log(activeFile.value)

}

const nextFileByMimeTypeFlat = (file) => {

  // console.log("next")
  // console.log(filesByMimeTypeFlat.value)

  if (!filesByMimeTypeFlat.value) return


  let id = filesByMimeTypeFlat.value.indexOf(file)

  id = id + 1
  id = (id + filesByMimeTypeFlat.value.length) % filesByMimeTypeFlat.value.length

  const newFile = filesByMimeTypeFlat.value[id]

  activeFile.value = newFile

  // console.log(activeFile.value)


}




onMounted(() => {



  const svf = inject(Symbol.for("vuetify:form"), { isReadonly: false })
    isFormReadOnly.value = svf.isReadonly.value

  getFiles()

})


const mimetypeIcon = (mimetype) => {
  if (mimetype == "audio/mp3") {
    return "music"
  }
  if (mimetype == "audio/ogg") {
    return "music"
  }
  if (mimetype == "audio/m4a") {
    return "music"
  }
  if (mimetype == "audio/x-m4a") {
    return "music"
  }
  if (mimetype == "image/jpg") {
    return "image"
  }
  if (mimetype == "image/jpeg") {
    return "image"
  }
  if (mimetype == "image/gif") {
    return "image"
  }
  if (mimetype == "image/png") {
    return "image"
  }
  if (mimetype == "video/mp4") {
    return "video"
  }
  return "file"
}



const fileDeleted = async () => {

  getFiles()
}



const onUpdateModelDialog = async (value) => {
  // console.log(value)
  if (!value) {
    activeFile.value = null
  }
}

const rowStyle = (i) => {

  let background = 'transparent'
  if (i % 2 == 0)
    background = '#EFEFEF'

  // if (activeFile.value && activeFile.value.id == filesByExtensionFlat.value[i].id)
  //   background = 'red'
  return "background: " + background + ";"
}


</script>
<style scoped>
.rowshowFileDialog {
  /* border-left: 10px solid white !important; */
  color: black !important;
}
</style>
